import { render, staticRenderFns } from "./data-global-beef-exports.vue?vue&type=template&id=7c59025e&scoped=true"
import script from "./data-global-beef-exports.vue?vue&type=script&lang=js"
export * from "./data-global-beef-exports.vue?vue&type=script&lang=js"
import style0 from "./data-global-beef-exports.vue?vue&type=style&index=0&id=7c59025e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c59025e",
  null
  
)

export default component.exports